<template>
    <LaBaseCard v-if="website?.hash">
        <LaNumberList :items="listItems">
            <template #script>
                <div class="text-container">
                    <p class="text">
                        To start measuring the blockrate on your website, you have to install our Javascript tag in your
                        HTML.
                    </p>
                    <p class="text">
                        Copy the code and paste it <strong>at the end of the BODY section</strong> of each page of your
                        website. Make sure the script doesn't get altered in any way.
                    </p>
                    <p class="text">
                        The Javascript tag is unique for each website, after installing it, check status of your website
                        in Websites tab. If status is `detected`, it is properly installed. Once the script is present,
                        it will start collecting data, you can see the results in the Dashboard tab 2 hours after
                        installation.
                    </p>
                </div>
                <div class="copy-code-container" id="kununu-script">
                    <div class="copy-code-content">
                        {{ kununuScript }}
                    </div>
                    <LaBaseButton
                        data-test="copy-code"
                        icon-left="note-multiple-outline"
                        @click.stop.prevent="copyScript"
                        text="Copy measurement code"
                    />
                </div>
            </template>
        </LaNumberList>
    </LaBaseCard>
</template>

<script>
import { computed } from "vue";
import store from "@/store/store";
import LaBaseCard from "@/components/BaseCard";
import LaNumberList from "@/components/NumberList";
import LaBaseButton from "@/components/button/BaseButton";
import { mutationTypes as flashMessagesMutationTypes } from "@/store/FlashMessages/types";
import { MESSAGE_STATE } from "@/store/FlashMessages/state";

function copyCode(code, codeName) {
    const textarea = document.createElement("textarea");
    textarea.style.cssText = "position:fixed;z-index:-9999;opacity:0;";
    textarea.value = code;

    document.body.appendChild(textarea);
    textarea.select();

    let message;
    try {
        document.execCommand("copy");
        message = {
            header: codeName + " was copied",
            messageState: MESSAGE_STATE.SUCCESS,
        };
    } catch (e) {
        message = {
            header: codeName + " cannot be copied'",
            messageState: MESSAGE_STATE.WARN,
        };
    }
    document.body.removeChild(textarea);
    store.commit(flashMessagesMutationTypes.addMessageToQueue, message);
}

export default {
    name: "LaInstallSteps",
    components: {
        LaBaseButton,
        LaBaseCard,
        LaNumberList,
    },
    props: {
        website: {
            required: true,
            type: Object,
        },
    },

    setup(props) {
        const adsTxtLink = computed(() => {
            let link = props.website.site_url;
            if (!link.endsWith("/")) {
                link += "/";
            }
            return link + "ads.txt";
        });

        const kununuScript = computed(() => {
            const innerScript = "<script src='https://cdn.ltba.io/acc/loader.js?aab=loader'></" + "script>";
            return `<iframe srcdoc="${innerScript}" style="display: none" data-web="${props.website.domain}" data-hash="${props.website.hash}"></iframe>`;
        });
        const copyScript = () => {
            copyCode(kununuScript.value, "Blockrate measurement code");
        };

        const listItems = computed(() => [
            {
                heading: "Insert our Measurement Code into your page",
                name: "script",
            },
        ]);

        return { kununuScript, copyScript, listItems, adsTxtLink };
    },
};
</script>

<style lang="scss" scoped>
.text {
    margin-bottom: 0.5rem;
    &-container {
        margin-bottom: 2rem;
    }
}

.copy-code {
    &-content {
        margin-bottom: 2rem;
        font-family: Courier New;
        @include --big-mobile-viewport {
            font-size: 0.9rem;
        }
        @include --mobile-viewport {
            font-size: 0.8rem;
        }
    }
    &-container {
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
        background-color: $blue;
        border-radius: $normal-radius;
        padding: 2rem;
        color: $dark-grey;
    }
}
#vendors-table {
    border-collapse: collapse;
}
#vendors-table th:first-child,
#vendors-table td:first-child {
    width: 50px;
}

#vendors-table th:nth-child(2),
#vendors-table td:nth-child(2) {
    width: 250px;
}
#vendors-table th,
#vendors-table td {
    border: 1px solid gray;
    padding: 10px;
}

body.dark {
    .copy-code {
        &-container {
            background-color: $light-black;
        }
    }

    strong {
        //background: $green-gradient;
        background: $green-2;
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}
</style>
